import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import type { ForumTag } from './types';

import { paginatedApiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumPostSchema } from './schemas';

export const forumPostsQueryOptions = (tag: ForumTag | null = null) =>
  infiniteQueryOptions({
    queryKey: QueryKeys.forum.index.tag(tag),
    queryFn: async ({ pageParam }) => {
      const response = await fetchJson('/forum/posts', {
        schema: paginatedApiResourceSchema(forumPostSchema.array()),
        params: {
          ...(tag !== null && { forumTag: tag }),
          pagination: { pageIndex: pageParam, pageSize: 20 },
        },
      });

      return response;
    },
    getNextPageParam: (lastPage) => lastPage.pagination.nextPage,
    initialPageParam: 1,
    staleTime: 60 * 1000,
    gcTime: tag === null ? Infinity : 5 * 60 * 1000,
  });

export const useForumPosts = (tag: ForumTag | null = null) => {
  return useInfiniteQuery(forumPostsQueryOptions(tag));
};
